import Handlebars from 'handlebars';
Handlebars.registerHelper('url_encode', input => encodeURIComponent(input));
const compileHandlebarTemplate = (template, data) => {
  const compiledTemplate = Handlebars.compile(template);
  return compiledTemplate(data);
};
export default compileHandlebarTemplate;
//# sourceMappingURL=compile-handlebar-template.js.map